// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3724":"VoltoFormBlockEdit","4328":"Widgets","4776":"VoltoFormBlockView"}[chunkId] + "." + {"3724":"57eae1ac","4328":"7b6f5da1","4776":"73d5e318"}[chunkId] + ".chunk.css";
};